import { handleRest } from '../../h2Api'
import * as assignmentActions from '../../actions/planning/assignments'

const initialState = {
  data: handleRest(null)
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case assignmentActions.ASSIGNMENT_LISTING_LOADED:
      return {
        ...state,
        data: handleRest(action)
      }
    default:
      return state
  }
}

export default reducers
